import { IPropHref, IPropName } from '@ucheba/utils/helpers/components/prop.types'

export interface IFeedbackBlockProps {
  title?: string
  list: {
    role?: string | null
    cardTitle?: string
    description?: string
    count?: string | null
    href: string
    overlay: string
    socials: {
      href: string
      name: string
      type: string
    }
    overlayImage: string
    previewImage: string
  }[]
  buttonText?: string
  onClick?: () => void
}

export interface IFeedBackItem extends IVideo<string> {
  role?: string | null
  cardTitle?: string
  description?: string
  count?: string | null
  socials: IFeedBackItemSocials
}

interface IFeedBackItemSocials extends IPropName, Required<IPropHref> {
  type: string
}

interface IVideo<OverlayType> extends Required<IPropHref>, IVideoOverlay<OverlayType> {
  previewImage?: string
}

interface IVideoOverlay<T> {
  overlay?: T
}

export interface IUseFeedbackListWithIcons {
  (list: IFeedBackItem[]): IFeedBackItem[]
}

export enum EIconName {
  vk = 'vk',
  instagram = 'instagram',
}

export type TIconName = keyof typeof EIconName
